import React from "react";
import { FormattedMessage } from "react-intl";
import makeCommandDispatcherWithMessageFeedback from "web/core/apollo/makeCommandDispatcherWithMessageFeedback";
import updateCartApolloCache from "../updateCartApolloCache";

const EnhanceAddMultipleItemsToCart = ({
  addToCartCallback,
  AddMultipleItemsToCartMutation,
}) =>
  makeCommandDispatcherWithMessageFeedback(
    {
      addToCart: (props) => () => {
        const preconditionFailed = (props) => {
          const hasValidQuantity = props.itemList.some(({ qty }) => {
            return qty > 0;
          });

          if (!hasValidQuantity) {
            return (
              <FormattedMessage
                id="modules.AddMultipleItemsToCart.errorMissingQty"
                defaultMessage="Please add at least one item to your cart"
              />
            );
          }

          return false;
        };

        const itemsToAdd = props.itemList.filter(({ qty }) => qty > 0);
        const variables = {
          input: {
            items: itemsToAdd.map(({ product, ...rest }) => {
              return {
                sku: product.sku,
                ...rest,
              };
            }),
          },
        };

        return {
          options: {
            mutation: AddMultipleItemsToCartMutation,
            variables: variables,
            update: (store, { data }) => {
              const response = data.addMultipleItemsToCart;
              if (response.success) {
                const cart = response.cart;
                updateCartApolloCache(store, cart);
              }
            },
          },
          callback: addToCartCallback({ ...props, itemList: itemsToAdd }),
          preconditionFailed: preconditionFailed(props),
        };
      },
    },
    false
  );

export default EnhanceAddMultipleItemsToCart;
